import { User } from "oidc-client";

export const isLoggedIn = (user?: User): boolean => user?.expires_at !== undefined;

export const isAuthenticated = (user?: User): boolean => isLoggedIn(user) && getUserRoles(user).length > 0;

export const hasRole = (userRoles: string[] = [], validRoles: string[]): boolean =>
  userRoles.some((r) => validRoles.includes(r.toLowerCase()));

export const getUserRoles = (user?: User): string[] => user?.profile?.roles ?? [];

export const getAccessToken = (user?: User | null): string => user?.access_token ?? '';
